import UpdateCandidateEmail from "./UpdateCandidateEmailForm";
export default UpdateCandidateEmail;